import React from 'react';
import { useTranslation } from '../../contexts/TranslationContext';

const TimelineSection = () => {
  const { t } = useTranslation();

  const milestones = [
    { id: 1, icon: '1' },
    { id: 2, icon: '2' },
    { id: 3, icon: '3' },
    { id: 4, icon: '4' },
    { id: 5, icon: '5' }
  ];


  return (
    <section className="py-24 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative">
          {/* Horizontal Connector Line - Desktop Only */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-primary/80 to-primary transform -translate-y-1/2"></div>
          
          {/* Milestones Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-4">
            {milestones.map((milestone, index) => (
              <div
                key={milestone.id}
                className="relative text-center"
              >
                {/* Milestone Circle */}
                <div className="relative z-10 bg-card rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center shadow-lg border-4 border-background">
                  <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-lg">{milestone.icon}</span>
                  </div>
                </div>
                
                {/* Milestone Content */}
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-foreground">
                    {t(`about.timeline.${milestone.id}.title`)}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {t(`about.timeline.${milestone.id}.desc`)}
                  </p>
                </div>

                {/* Vertical Connector Line - Mobile Only */}
                {index < milestones.length - 1 && (
                  <div className="lg:hidden absolute top-16 left-1/2 transform -translate-x-1/2 w-0.5 h-8 bg-primary"></div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Section Title */}
        <div className="text-center mt-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            {t('about.timeline.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('about.timeline.subtitle')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TimelineSection;
